module.exports = __webpack_public_path__ + "static/img/vertical.17cde667.svg";